import { $getFiltersRequestType } from '@shared/types';
import { z } from 'zod';

export const $ActivitySphere = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string().optional(),
});

export type ActivitySphere = z.infer<typeof $ActivitySphere>;

export const $GetActivitySpheresResponse =
  $getFiltersRequestType($ActivitySphere);
export type GetActivitySpheresResponse = z.infer<
  typeof $GetActivitySpheresResponse
>;
